import { default as SectionedList } from './SectionedList';

export default SectionedList;
